import "./App.scss";
import React, { Suspense } from "react";
import { Route, BrowserRouter, Routes, useLocation, useNavigate } from "react-router-dom";
import { routers } from "routers/index";
import "./i18n/i18n";
import zhCN from "antd/lib/locale/zh_CN";
import { ConfigProvider } from "antd";
import { isMobile } from "utils/device";
import { getDeviceRedirectPath } from "routers/mobileRedirect";

const getRoutePath = (parentPath: string, childPath: string) => {
  if (parentPath === "/") {
    return childPath;
  }

  if (childPath.startsWith(parentPath)) {
    return childPath;
  }

  return `${parentPath}${childPath}`;
};

function DeviceRedirect() {
  const location = useLocation();
  const navigate = useNavigate();

  React.useEffect(() => {
    const nextPath = getDeviceRedirectPath(
      `${location.pathname}${location.search}${location.hash}`,
      isMobile()
    );

    if (nextPath) {
      navigate(nextPath, { replace: true });
    }
  }, [location.hash, location.pathname, location.search, navigate]);

  return null;
}

export default function App() {
  return (
    <ConfigProvider locale={zhCN}>
      <BrowserRouter>
        <DeviceRedirect />
        <Routes>
          {routers.map((item, i) => {
            if (Array.isArray(item.children)) {
              return (
                <Route
                  key={i}
                  path={item.path}
                  element={
                    <Suspense>
                      <item.component />
                    </Suspense>
                  }
                >
                  {item.children.map((child, k) => (
                    <Route
                      key={i}
                      path={getRoutePath(item.path, child.path)}
                      element={
                        <Suspense>
                          <child.component />
                        </Suspense>
                      }
                    />
                  ))}
                </Route>
              );
            }
            return (
              <Route
                key={i}
                path={item?.path}
                element={
                  <Suspense>
                    <item.component />
                  </Suspense>
                }
              />
            );
          })}
        </Routes>
      </BrowserRouter>
    </ConfigProvider>
  );
}
